/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'



/** @type {import('Simple/types.js').View} */
export default function DateInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/DateInput",
  onChange
  
}) {
let questionAnswerValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer',
})
let questionAnswerChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer',
})
let questionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isValid',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onKeyUp = fromHelpers.useOnKeyUp({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 width={250}
 flexGrow={0}
 type="text"
 paddingLeft={0}
 paddingTop={dtSpaceXs}
 backgroundColor="transparent"
 data="question.answer"
 onChange={questionAnswerChangeData}
 value={questionAnswerValueData}
 data="question.isValid"
 invalid={!questionIsValidValueData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXxs}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
 placeholder="mm/dd/yyyy"
 autoFocus={true}
 onKeyUp={onKeyUp}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}